import {BasicStatusTranslationService, ProductSettingsTranslationService} from 'src/app/shared/translations';

/**
 * Blueprint for the club-overview entity.
 */
export class Webhook {
  public id: number;
  public name: string;
  public status: string;
  public checked: boolean;

  public statuses: Array<any> = [
    { value: 'inactive', status: this.statusTranslations.i18nInactive },
    { value: 'active', status: this.statusTranslations.i18nActive }
  ];

  public names: Array<any> = [
    { value: 'customer', name: this.productTranslations.customer },
    { value: 'invoice', name: this.productTranslations.invoice },
  ];

  constructor(
    webhooks: any,
    private statusTranslations: BasicStatusTranslationService,
    private productTranslations: ProductSettingsTranslationService
  ) {
    this.id = webhooks.id;
    this.name = webhooks.name;
    this.status = webhooks.status;
    this.checked = webhooks.status === 'active' ? true : null;
  }

  /**
   * Translates the status text
   */
  public get translatedStatus(): string {
    const translatedStatus = this.statuses.find(status => this.status === status.value);
    return translatedStatus ? translatedStatus.status : this.status;
  }

  /**
   * Translates the status text
   */
  public get translatedName(): string {
    const translatedStatus = this.names.find(name => this.name === name.value);
    return translatedStatus ? translatedStatus.name : this.name;
  }

}
